import docSitemap from 'docs/routes/docSitemap';
import paths from './paths';

const sitemap = [
  // {
  //   id: 'configuration',
  //   subheader: 'Configuration',
  //   key: 'configuration',
  //   icon: 'mingcute:settings-2-line',
  //   items: [
  //     {
  //       name: 'ERP Config',
  //       path: paths.erpConfig,
  //       pathKey: 'erp-config',
  //       icon: 'mingcute:key-2-line',
  //       active: true,
  //     }
  //   ]
  // },
  {
    id: 'dashboard',
    subheader: 'Homepage',
    key: 'dashboard',
    icon: 'material-symbols:data-exploration-outline-rounded',
    items: [
      // {
      //   name: 'E-commerce',
      //   key: 'e_commerce',
      //   path: paths.ecommerce,
      //   pathName: 'e-commerce',
      //   icon: 'material-symbols:shopping-cart-outline',
      //   active: true,
      // },
      // {
      //   name: 'Project ',
      //   path: paths.project,
      //   key: 'project',
      //   pathName: 'project ',
      //   icon: 'material-symbols:pending-actions-rounded',
      //   active: true,
      // },
      // {
      //   name: 'CRM',
      //   key: 'crm',
      //   path: paths.crm,
      //   pathName: 'crm',
      //   icon: 'material-symbols:phone-in-talk-outline-rounded',
      //   active: true,
      // },
      {
        name: 'CRM-Q ',
        key: 'CRM-Q',
        path: '/m/crmq',
        pathName: 'crm-q',
        icon: 'mingcute:chart-bar-line',
        active: true,
      },
      {
        name: 'Kanban Board',
        key: 'CRM-Q-Kanban',
        path: '/m/crmq/kanban',
        pathName: 'crm-q-kanban',
        icon: 'material-symbols:view-kanban-outline-rounded',
        active: true,
      },
      // {
      //   name: 'Documents',
      //   key: 'docq',
      //   path: '/m/docq/my-documents',
      //   pathName: 'docq',
      //   icon: 'material-symbols:folder-outline-rounded',
      //   active: true,
      //   selectionPrefix: '/m/docq',
      //   items: [
      //     { name: 'My documents', key: 'docq-my', path: '/m/docq/my-documents', pathName: 'docq-my', active: true },
      //     { name: 'Create documents', key: 'docq-new', path: '/m/docq/new', pathName: 'docq-new', active: true },
      //     { name: 'All my dump files', key: 'docq-register', path: '/m/docq/register', pathName: 'docq-register', active: true },
      //     { name: 'Shared with me', key: 'docq-shared-with-me', path: '/m/docq/shared-with-me', pathName: 'docq-shared-with-me', active: true },
      //     { name: 'Shared by me', key: 'docq-shared-by-me', path: '/m/docq/shared-by-me', pathName: 'docq-shared-by-me', active: true },
      //     { name: 'Revision', key: 'docq-changes', path: '/m/docq/changes-requested', pathName: 'docq-changes', active: true },
      //     { name: 'Documents for Review', key: 'docq-review', path: '/m/docq/for-review', pathName: 'docq-review', active: true },
      //     { name: 'Documents for Approval', key: 'docq-approval', path: '/m/docq/for-approval', pathName: 'docq-approval', active: true },
      //     { name: 'Revoke documents', key: 'docq-revoke', path: '/m/docq/revoke', pathName: 'docq-revoke', active: true },
      //   ],
      // },
      {
        name: 'Supplier Portal',
        key: 'supplierq',
        path: '/m/supplierq',
        pathName: 'supplierq',
        icon: 'material-symbols:local-shipping-outline',
        active: true,
      },
      // {
      //   name: 'Analytics',
      //   key: 'analytics',
      //   path: paths.analytics,
      //   pathName: 'analytics',
      //   icon: 'material-symbols:query-stats-rounded',
      //   active: true,
      // },
      // {
      //   name: 'HRM',
      //   key: 'hrm',
      //   path: paths.hrm,
      //   pathName: 'hrm',
      //   icon: 'material-symbols:manage-accounts-outline',
      //   active: true,
      // },
      // {
      //   name: 'Time Tracker',
      //   key: 'time-tracker',
      //   path: paths.timeTracker,
      //   pathName: 'time-tracker',
      //   icon: 'material-symbols:timer-outline-rounded',
      //   active: true,
      // },
      // {
      //   name: 'Hiring',
      //   key: 'hiring',
      //   path: paths.hiring,
      //   pathName: 'hiring',
      //   icon: 'material-symbols:work-outline',
      //   active: true,
      // },
    ],
  },
  {
    id: 'apps',
    subheader: 'Apps',
    key: 'apps',
    icon: 'material-symbols:widgets-outline-rounded',
    items: [
      // {
      //   name: 'E-commerce',
      //   key: 'e_commerce',
      //   pathName: 'ecommerce',
      //   icon: 'material-symbols:storefront-outline-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Admin',
      //       key: 'admin',
      //       pathName: 'admin',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Product listing',
      //           key: 'product_listing',
      //           path: paths.adminProductListing,
      //           pathName: 'product-listing',
      //           active: true,
      //         },
      //         {
      //           name: 'Product list',
      //           key: 'product_list',
      //           path: paths.adminProductList,
      //           pathName: 'product-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Order list',
      //           key: 'order_list',
      //           path: paths.adminOrderList,
      //           pathName: 'order-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Order',
      //           key: 'order',
      //           path: paths.adminOrder,
      //           pathName: 'order',
      //           active: true,
      //         },
      //         {
      //           name: 'Create order',
      //           key: 'create_order',
      //           path: paths.adminCreateOrder,
      //           pathName: 'create-order',
      //           active: true,
      //         },
      //         {
      //           name: 'Refund',
      //           key: 'refund',
      //           path: paths.adminRefund,
      //           pathName: 'refund',
      //           active: true,
      //         },
      //         {
      //           name: 'Invoice list',
      //           key: 'invoice_list',
      //           path: paths.adminInvoiceList,
      //           pathName: 'invoice-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Invoice',
      //           key: 'invoice',
      //           path: paths.adminInvoice,
      //           pathName: 'invoice',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Customer',
      //       key: 'customer',
      //       pathName: 'customer',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Homepage',
      //           key: 'homepage',
      //           path: paths.ecommerceHomepage,
      //           pathName: 'homepage',
      //           active: true,
      //         },
      //         {
      //           name: 'Products',
      //           key: 'products',
      //           path: paths.products,
      //           pathName: 'products',
      //           active: true,
      //         },
      //         {
      //           name: 'Product details',
      //           key: 'product_details',
      //           path: paths.productDetails(),
      //           pathName: 'product-details',
      //           active: true,
      //         },
      //         {
      //           name: 'Cart',
      //           key: 'cart',
      //           path: paths.cart,
      //           pathName: 'cart',
      //           active: true,
      //         },
      //         {
      //           name: 'Customer account',
      //           key: 'customer_account',
      //           path: paths.customerAccount,
      //           pathName: 'customer-account',
      //           active: true,
      //         },
      //         {
      //           name: 'Checkout',
      //           key: 'checkout',
      //           path: paths.checkout,
      //           pathName: 'checkout',
      //           active: true,
      //         },
      //         {
      //           name: 'Payment',
      //           key: 'payment',
      //           path: paths.payment,
      //           pathName: 'payment',
      //           active: true,
      //         },
      //         {
      //           name: 'Order confirmation',
      //           key: 'order_confirmation',
      //           path: paths.orderConfirmation,
      //           pathName: 'order-confirmation',
      //           active: true,
      //         },
      //         {
      //           name: 'Wishlist',
      //           key: 'wishlist',
      //           path: paths.wishlist,
      //           pathName: 'wishlist',
      //           active: true,
      //         },
      //         {
      //           name: 'Order list',
      //           key: 'order_list',
      //           path: paths.orderList,
      //           pathName: 'order-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Order details',
      //           key: 'order_details',
      //           path: paths.orderDetails,
      //           pathName: 'order-details',
      //           active: true,
      //         },
      //         {
      //           name: 'Track order',
      //           key: 'track_order',
      //           path: paths.orderTrack,
      //           pathName: 'track-order',
      //           active: true,
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   name: 'CRM',
      //   pathName: 'crm',
      //   key: 'crm_pages',
      //   icon: 'material-symbols:phone-in-talk-outline-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Deals',
      //       key: 'deals',
      //       path: paths.deals,
      //       pathName: 'deals',
      //       active: true,
      //     },
      //     {
      //       name: 'Lead details',
      //       key: 'lead_details',
      //       path: paths.leadDetails,
      //       pathName: 'lead-details',
      //       active: true,
      //     },
      //     {
      //       name: 'Deal details',
      //       key: 'deal_details',
      //       path: paths.dealDetails,
      //       pathName: 'deal-details',
      //       active: true,
      //     },
      //     {
      //       name: 'Add contact',
      //       key: 'add_contact',
      //       path: paths.addContact,
      //       pathName: 'add-contact',
      //       active: true,
      //     },
      //   ],
      // },
      // {
      //   name: 'CRM-Q',
      //   pathName: 'crm-q',
      //   key: 'CRM-Q',
      //   icon: 'mingcute:user-3-line',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Deals',
      //       key: 'deals',
      //       path: paths.deals,
      //       pathName: 'deals',
      //       active: true,
      //     },
      //     {
      //       name: 'Lead details',
      //       key: 'lead_details',
      //       path: paths.leadDetails,
      //       pathName: 'lead-details',
      //       active: true,
      //     },
      //     {
      //       name: 'Deal details',
      //       key: 'deal_details',
      //       path: paths.dealDetails,
      //       pathName: 'deal-details',
      //       active: true,
      //     },
      //     {
      //       name: 'Add contact',
      //       key: 'add_contact',
      //       path: paths.addContact,
      //       pathName: 'add-contact',
      //       active: true,
      //     },
      //   ],
      // },
      // {
      //   name: 'HRM',
      //   pathName: 'hrm',
      //   key: 'hrm',
      //   icon: 'material-symbols:manage-accounts-outline',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Payroll',
      //       key: 'payroll',
      //       pathName: 'payroll',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Payroll Overview',
      //           key: 'payroll_overview',
      //           path: paths.hrmPayrollDashboard,
      //           pathName: 'payroll-overview',
      //           active: true,
      //         },
      //         {
      //           name: 'Run Payroll',
      //           key: 'run_payroll',
      //           path: paths.hrmPayrollRun,
      //           pathName: 'run-payroll',
      //           active: true,
      //         },
      //         {
      //           name: 'Payroll Review',
      //           key: 'payroll_review',
      //           path: paths.hrmPayrollReview,
      //           pathName: 'payroll-review',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Performance Management',
      //       key: 'performance_management',
      //       pathName: 'performance-management',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Goals',
      //           key: 'goals',
      //           path: paths.hrmPerformanceGoals,
      //           pathName: 'goals',
      //           active: true,
      //         },
      //         {
      //           name: 'New Goal',
      //           key: 'new_goal',
      //           path: paths.hrmPerformanceNewGoal,
      //           pathName: 'new-goal',
      //           active: true,
      //         },
      //         {
      //           name: 'Appraisal List',
      //           key: 'appraisal_list',
      //           path: paths.hrmPerformanceAppraisalList,
      //           pathName: 'appraisal-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Appraisal Cycle',
      //           key: 'appraisal_cycle',
      //           path: paths.hrmPerformanceAppraisalCycle,
      //           pathName: 'appraisal-cycle',
      //           active: true,
      //         },
      //         {
      //           name: 'Feedback',
      //           key: 'feedback',
      //           path: paths.hrmPerformanceFeedback,
      //           pathName: 'feedback',
      //           active: true,
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   name: 'Invoice',
      //   key: 'invoice',
      //   pathName: 'invoice',
      //   icon: 'material-symbols:receipt-long-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Invoice List',
      //       key: 'invoice_list',
      //       path: paths.invoiceList,
      //       pathName: 'invoice-list',
      //       active: true,
      //     },
      //     {
      //       name: 'Create Invoice',
      //       key: 'create_invoice',
      //       path: paths.createInvoice,
      //       pathName: 'create-invoice',
      //       active: true,
      //     },
      //     {
      //       name: 'Invoice Preview',
      //       key: 'invoice_preview',
      //       path: paths.invoicePreview,
      //       pathName: 'invoice-preview',
      //       selectionPrefix: '/invoice/invoice-preview',
      //       active: true,
      //     },
      //   ],
      // },
      {
        name: 'CRM-Q',
        pathName: 'crm-q',
        key: 'CRM-Q',
        // Updated from mail icon to a handshake (standard for CRM/Deals)
        icon: 'material-symbols:handshake-outline-rounded', 
        active: true,
        items: [
          {
            name: 'Lead',
            key: 'Lead',
            path: '/m/crmq/lead-list',
            selectionPrefix: '/m/crmq/lead',
            icon: 'material-symbols:person-search-outline-rounded', 
            pathName: 'lead', 
            active: true,
          },
          {
            name: 'Opportunity',
            key: 'Opportunity',
            path: '/m/crmq/opportunity-list',
            selectionPrefix: '/m/crmq/opportunity',
            icon: 'material-symbols:lightbulb-outline-rounded', 
            pathName: 'opportunity',
            active: true,
          },
        ],
      },
      {
        name: 'Email',
        pathName: 'email',
        key: 'email',
        icon: 'material-symbols:mail-outline-rounded',
        active: true,
        items: [
          {
            name: 'Inbox',
            key: 'inbox',
            path: '/m/emailq/email/list/inbox',
            selectionPrefix: '/m/emailq/email',
            pathName: 'emailq',
            active: true,
          },
          // {
          //   name: 'Email detail',
          //   key: 'email_detail',
          //   selectionPrefix: '/email/details',
          //   path: paths.emailDetails('inbox', '1'),
          //   pathName: 'email-detail',
          //   active: true,
          // },
        ],
      },
      // {
      //   name: 'Events',
      //   key: 'events',
      //   pathName: 'events',
      //   icon: 'material-symbols:calendar-clock-outline-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Create event',
      //       key: 'create_event',
      //       path: paths.createEvent,
      //       pathName: 'create-event',
      //       active: true,
      //     },
      //     {
      //       name: 'Event detail',
      //       key: 'event_detail',
      //       path: paths.events,
      //       pathName: 'event-detail',
      //       active: true,
      //     },
      //   ],
      // },
      // {
      //   name: 'Kanban',
      //   key: 'kanban',
      //   pathName: 'kanban',
      //   icon: 'material-symbols:view-kanban-outline-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Kanban',
      //       key: 'kanban',
      //       path: paths.kanban,
      //       pathName: 'kanban',
      //       active: true,
      //     },
      //     {
      //       name: 'Boards',
      //       key: 'boards',
      //       path: paths.boards,
      //       pathName: 'boards',
      //       active: true,
      //     },
      //     {
      //       name: 'Create board',
      //       key: 'create_board',
      //       path: paths.createBoard,
      //       pathName: 'create-board',
      //       active: true,
      //     },
      //   ],
      // },
      // {
      //   name: 'Hiring',
      //   key: 'hiring',
      //   pathName: 'hiring',
      //   icon: 'material-symbols:work-outline',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Admin',
      //       key: 'admin',
      //       pathName: 'admin',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Job Opening',
      //           key: 'job_opening',
      //           path: paths.hiringJobOpening,
      //           pathName: 'job-opening',
      //           active: true,
      //         },
      //         {
      //           name: 'Pipeline',
      //           key: 'pipeline',
      //           path: paths.hiringPipeline,
      //           pathName: 'pipeline',
      //           active: true,
      //         },
      //         {
      //           name: 'New Opening',
      //           key: 'new_opening',
      //           path: paths.hiringNewOpening,
      //           pathName: 'new-opening',
      //           active: true,
      //         },
      //         {
      //           name: 'Candidate Details',
      //           key: 'candidate_details',
      //           path: paths.hiringCandidateDetails,
      //           pathName: 'candidate-details',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Candidate',
      //       key: 'candidate',
      //       pathName: 'candidate',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Job List',
      //           key: 'job_list',
      //           path: paths.hiringJobList,
      //           pathName: 'job-list',
      //           active: true,
      //         },
      //         {
      //           name: 'Job Details',
      //           key: 'job_details',
      //           path: paths.hiringJobDetails(),
      //           selectionPrefix: '/hiring/candidate/job-details',
      //           pathName: 'job-details',
      //           active: true,
      //         },
      //         {
      //           name: 'Job Application',
      //           key: 'job_application',
      //           path: paths.hiringJobApplication,
      //           pathName: 'job-application',
      //           active: true,
      //         },
      //       ],
      //     },
      //   ],
      // },
      // {
      //   name: 'Chat',
      //   key: 'chat',
      //   path: paths.chat,
      //   pathName: 'chat',
      //   selectionPrefix: '/chat',
      //   icon: 'material-symbols:chat-bubble-outline-rounded',
      //   active: true,
      // },
      // {
      //   name: 'Social',
      //   key: 'social',
      //   path: paths.social,
      //   pathName: 'social',
      //   selectionPrefix: '/social',
      //   icon: 'material-symbols:account-box-outline',
      //   active: true,
      // },
      // {
      //   name: 'File manager',
      //   key: 'file_manager',
      //   path: paths.fileManager,
      //   pathName: 'file-manager',
      //   selectionPrefix: '/file-manager',
      //   icon: 'material-symbols:folder-outline-rounded',
      //   active: true,
      // },
      // {
      //   name: 'Calendar',
      //   key: 'calendar',
      //   path: paths.calendar,
      //   pathName: 'calendar',
      //   icon: 'material-symbols:calendar-month-outline',
      //   active: true,
      // },
      // {
      //   name: 'Scheduler',
      //   key: 'scheduler',
      //   path: paths.scheduler,
      //   pathName: 'scheduler',
      //   icon: 'material-symbols:calendar-add-on',
      //   active: true,
      // },
      // {
      //   name: 'Content',
      //   key: 'content',
      //   pathName: 'content',
      //   icon: 'material-symbols:library-books-outline-rounded',
      //   active: true,
      //   items: [
      //     {
      //       name: 'Homepage',
      //       key: 'homepage',
      //       path: paths.content,
      //       pathName: 'content',
      //       active: true,
      //     },
      //     {
      //       name: 'Search Content',
      //       key: 'content_search',
      //       path: paths.contentSearch,
      //       pathName: 'content-search',
      //       active: true,
      //     },
      //     {
      //       name: 'Topics',
      //       key: 'content_topics',
      //       path: paths.contentTopics,
      //       pathName: 'content-topics',
      //       active: true,
      //     },
      //     {
      //       name: 'Blog Details',
      //       key: 'content_blog_details',
      //       path: paths.blogDetails('1'),
      //       selectionPrefix: '/content/blogs',
      //       pathName: 'blogs',
      //       active: true,
      //     },
      //     {
      //       name: 'Podcast Details',
      //       key: 'content_podcast_details',
      //       path: paths.podcastDetails('1'),
      //       selectionPrefix: '/content/podcasts',
      //       pathName: 'podcasts',
      //       active: true,
      //     },
      //     {
      //       name: 'Video Details',
      //       key: 'content_video_details',
      //       path: paths.videoDetails('1'),
      //       selectionPrefix: '/content/videos',
      //       pathName: 'videos',
      //       active: true,
      //     },
      //     {
      //       name: 'Create Blog',
      //       key: 'content_create_blog',
      //       path: paths.createBlog,
      //       pathName: 'create-blog',
      //       active: true,
      //     },
      //     {
      //       name: 'Upload Media',
      //       key: 'content_upload_media',
      //       path: paths.uploadMedia,
      //       pathName: 'upload-media',
      //       active: true,
      //     },
      //   ],
      // },
      // ],
      // },
      // {
      //   id: 'pages',
      //   subheader: 'Pages',
      //   key: 'pages',
      //   icon: 'material-symbols:view-quilt-outline',
      //   items: [
      //     {
      //       name: 'Landing',
      //       key: 'landing',
      //       pathName: 'landing',
      //       active: true,
      //       icon: 'material-symbols:flight-land-rounded',
      //       items: [
      //         {
      //           name: 'Homepage',
      //           key: 'landing_homepage',
      //           path: paths.landingHomepage,
      //           pathName: 'homepage',
      //           active: true,
      //         },
      //         {
      //           name: 'About Us',
      //           key: 'landing_about',
      //           path: paths.landingAbout,
      //           pathName: 'about-us',
      //           active: true,
      //         },
      //         {
      //           name: 'FAQ',
      //           key: 'landing_faq',
      //           path: paths.landingFaq,
      //           pathName: 'landing-faq',
      //           active: true,
      //         },
      //         {
      //           name: 'Contact',
      //           key: 'landing_contact',
      //           path: paths.landingContact,
      //           pathName: 'contact',
      //           active: true,
      //         },
      //         {
      //           name: '404',
      //           key: 'landing_404',
      //           path: paths.landing404,
      //           pathName: 'landing-404',
      //           active: true,
      //         },
      //         {
      //           name: 'Coming Soon',
      //           key: 'landing_comingSoon',
      //           path: paths.landingComingSoon,
      //           pathName: 'landing-comingSoon',
      //           active: true,
      //         },
      //         {
      //           name: 'Maintenance',
      //           key: 'landing_maintenance',
      //           path: paths.landingMaintenance,
      //           pathName: 'landing-maintenance',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Starter',
      //       key: 'starter',
      //       path: paths.starter,
      //       pathName: 'starter',
      //       icon: 'material-symbols:play-circle-outline-rounded',
      //       active: true,
      //     },
      //     {
      //       name: 'Account',
      //       key: 'account',
      //       path: paths.account,
      //       pathName: 'account',
      //       icon: 'material-symbols:admin-panel-settings-outline-rounded',
      //       active: true,
      //     },
      //     {
      //       name: 'Notifications',
      //       key: 'notifications',
      //       path: paths.notifications,
      //       pathName: 'notifications',
      //       icon: 'material-symbols:notifications-outline-rounded',
      //       active: true,
      //     },
      //     {
      //       name: 'Authentication',
      //       key: 'authentication',
      //       pathName: 'authentication',
      //       icon: 'material-symbols:security-rounded',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Login',
      //           key: 'login',
      //           path: paths.defaultJwtLogin,
      //           pathName: 'login',
      //           active: true,
      //         },
      //         {
      //           name: 'Sign up',
      //           key: 'sign_up',
      //           path: paths.defaultJwtSignup,
      //           pathName: 'sign-up',
      //           active: true,
      //         },
      //         {
      //           name: 'Forgot password',
      //           key: 'forgot_password',
      //           path: paths.defaultJwtForgotPassword,
      //           pathName: 'forgot-password',
      //           active: true,
      //         },
      //         {
      //           name: '2FA',
      //           key: '2FA',
      //           path: paths.defaultJwt2FA,
      //           pathName: '2FA',
      //           active: true,
      //         },
      //         {
      //           name: 'Set password',
      //           key: 'set_password',
      //           path: paths.defaultJwtSetPassword,
      //           pathName: 'default-set-password',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Error 404',
      //       key: 'error_404',
      //       pathName: 'error',
      //       active: true,
      //       icon: 'material-symbols:warning-outline-rounded',
      //       path: paths[404],
      //     },
      //   ],
      // },
      // {
      //   id: 'misc',
      //   subheader: 'Misc',
      //   key: 'misc',
      //   icon: 'material-symbols:dashboard-customize-outline-rounded',
      //   items: [
      //     {
      //       name: 'Pricing',
      //       key: 'pricing',
      //       pathName: 'pricing',
      //       active: true,
      //       icon: 'material-symbols:sell-outline',
      //       items: [
      //         {
      //           name: 'Pricing column',
      //           key: 'pricing_column',
      //           path: paths.pricingColumn,
      //           pathName: 'pricing-column',
      //           active: true,
      //         },
      //         {
      //           name: 'Pricing table',
      //           key: 'pricing_table',
      //           path: paths.pricingTable,
      //           pathName: 'pricing-table',
      //           active: true,
      //         },
      //       ],
      //     },
      //     {
      //       name: 'FAQ',
      //       key: 'faq',
      //       path: paths.faq,
      //       pathName: 'faq',
      //       selectionPrefix: 'faq',
      //       icon: 'material-symbols:question-mark-rounded',
      //       active: true,
      //     },
      //     {
      //       name: 'Multi level',
      //       key: 'multi_level',
      //       pathName: 'multi-level',
      //       icon: 'material-symbols:layers-outline-rounded',
      //       active: true,
      //       items: [
      //         {
      //           name: 'Level two (1)',
      //           key: 'level_two_1',
      //           path: '#!',
      //           pathName: 'multi-level-2',
      //           active: true,
      //         },
      //         {
      //           name: 'Level two (2)',
      //           key: 'level_two_2',
      //           pathName: 'multi-level-3',
      //           active: true,
      //           items: [
      //             {
      //               name: 'Level three (1)',
      //               key: 'level_three_1',
      //               path: '#!',
      //               pathName: 'multi-level-item-3',
      //               active: true,
      //             },
      //             {
      //               name: 'Level three (2)',
      //               key: 'level_three_2',
      //               path: '#!',
      //               pathName: 'multi-level-item-4',
      //               active: true,
      //             },
      //           ],
      //         },
      //         {
      //           name: 'Level two (3)',
      //           key: 'level_two_3',
      //           pathName: 'multi-level-4',
      //           active: true,
      //           items: [
      //             {
      //               name: 'Level three (3)',
      //               key: 'level_three_3',
      //               path: '#!',
      //               pathName: 'multi-level-item-6',
      //               active: true,
      //             },
      //             {
      //               name: 'Level three (4)',
      //               key: 'level_three_4',
      //               pathName: 'multi-level-item-7',
      //               active: true,
      //               items: [
      //                 {
      //                   name: 'Level four (1)',
      //                   key: 'level_four_1',
      //                   path: '#!',
      //                   pathName: 'multi-level-item-8',
      //                   active: true,
      //                 },
      //                 {
      //                   name: 'Level four (2)',
      //                   key: 'level_four_2',
      //                   pathName: 'multi-level-item-9',
      //                   active: true,
      //                   items: [
      //                     {
      //                       name: 'Level five (1)',
      //                       key: 'level_five_1',
      //                       path: '#!',
      //                       pathName: 'multi-level-item-10',
      //                       active: true,
      //                     },
      //                     {
      //                       name: 'Level five (2)',
      //                       key: 'level_five_2',
      //                       path: '#!',
      //                       pathName: 'multi-level-item-11',
      //                       active: true,
      //                     },
      //                   ],
      //                 },
      //               ],
      //             },
      //           ],
      //         },
      //       ],
      //     },
      //     {
      //       name: 'Showcase',
      //       path: paths.showcase,
      //       pathName: 'showcase',
      //       icon: 'material-symbols:monitor-outline-rounded',
      //       active: true,
      //     },
    ],
  },
  //...docSitemap,
];

export default sitemap;
